import PerfectScrollbar from 'react-perfect-scrollbar';
import styled, { css } from 'styled-components';
import {
  FnPerfectScrollbarVariants,
  TRACK_OPACITY,
  TRACK_BACKGROUND,
  THUMB_BACKGROUND,
  THUMB_OPACITY
} from './constants';

const railWidth = '0.385rem';
const Thumb = css`
  border-radius: 0.385rem;
`;

export const PerfectScrollbarStyled = styled(PerfectScrollbar)<{
  styled: number;
  variant: FnPerfectScrollbarVariants;
}>`
  ${(props) =>
    props.styled &&
    css`
      // To apply styles for native
      position: relative;
      height: 100%;

      &:hover > .ps__rail-x,
      &:hover > .ps__rail-y,
      &.ps--focus > .ps__rail-x,
      &.ps--focus > .ps__rail-y,
      &.ps--scrolling-x > .ps__rail-x,
      &.ps--scrolling-y > .ps__rail-y {
        opacity: ${TRACK_OPACITY[props.variant]} !important;
      }

      > .ps__rail-x,
      > .ps__rail-y {
        z-index: 2;
        background-color: ${TRACK_BACKGROUND[props.variant]} !important;
      }

      > .ps__rail-x {
        height: ${railWidth};

        .ps__thumb-x {
          ${Thumb};
          background-color: ${THUMB_BACKGROUND[props.variant]} !important;
          opacity: ${THUMB_OPACITY[props.variant]} !important;
          height: ${railWidth};
          bottom: 0;
        }
      }

      > .ps__rail-y {
        width: ${railWidth};

        .ps__thumb-y {
          ${Thumb};
          background-color: ${THUMB_BACKGROUND[props.variant]} !important;
          opacity: ${THUMB_OPACITY[props.variant]} !important;
          width: ${railWidth};

          right: 0;
        }
      }
    `}
`;
